<template>
    <div >
        <span @click="back()" class="exit  el-icon-back"> 返回</span>
         <a href="javascript:;" class="btns mt15" v-print="'#pdfDom'">打印</a>
         <p class="tit">个人信息表</p>
         <table id='pdfDom'>
             <!--基本情况  -->
               <tr>
                    <td colspan="3" rowspan="5"  class="h40 w90 bold">基本情况</td>
                    <td colspan='4' class="w120 h40">姓名</td>
                    <td colspan='4' class="w120 ">{{data.xm}}</td>
                    <td colspan='4' class="w120 ">通讯地址</td>
                    <td colspan='8' class="w210 ">{{data.txdz}}</td>
                    <td colspan="4" rowspan="5"  class="w150">
                        <img style="max-width: 125px;" :src="loginUrl+data.zp" alt="">
                    </td>
                </tr>
                <tr>
                    <td colspan='4' class="w120 h40">性别</td>
                    <td colspan='4' class="w120 ">{{data.xb}}</td>
                    <td colspan='4' class="w120 ">出生日期</td>
                    <td colspan='8' class="w210 ">{{data.csrq}}</td>
                </tr>
                 <tr>
                     <td colspan='4' class="w120 h40">民族</td>
                    <td colspan='4' class="w120 ">{{data.mz}}</td>
                    <td colspan='4' class="w120 ">政治面貌</td>
                    <td colspan='8' class="w210 ">{{data.zzmm}}</td>
                </tr>
                 <tr>
                    <td colspan='4' class="w120 h40">婚姻状况</td>
                    <td colspan='4' class="w120 ">{{data.hyzk}}</td>
                    <td colspan='4' class="w120 ">宗教信仰</td>
                    <td colspan='8' class="w210 ">{{data.xyzj}}</td>
                </tr>
                <tr>
                    <td colspan='4' class="w120 h40">联系电话</td>
                    <td colspan='4' class="w120 ">{{data.mobile}}</td>
                    <td colspan='4' class="w120 ">血型</td>
                    <td colspan='8' class="w210 ">{{data.xx}}</td>
                </tr>
                <tr>
                    <td colspan='4'  class="w120 h40">身份证号码</td>
                    <td colspan='23'  class="h40 w210">{{data.sfzjh}}</td>
                </tr>
                <!-- 学籍情况 -->
             <tr>
                    <td colspan='3'  rowspan='5' class="bold">学籍情况</td>
                    <td colspan='4' class="w120 h40">入学日期</td>
                    <td colspan='4' class="w120 h40">{{data.rxny}}</td>
                    <td colspan='4' class="w110 h40">类型</td>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='4' class="w120 h40">在校状态</td>
                    <td colspan='4' class="w120 h40">{{data.stu_state}}</td>
                </tr>
                <tr>
                    <td colspan='4' class="w120 h40">专业</td>
                    <td colspan='4' class="w120 h40">{{data.zy}}</td>
                    <td colspan='4' class="w110 h40">班级</td>
                    <td colspan='4' class="w120 h40">{{data.szbh}}</td>
                    <td colspan='4' class="w120 h40">学生属性</td>
                    <td colspan='4' class="w120 h40"></td>
                </tr>
                 <tr>
                    <td colspan='4' class="w120 h40">学生角色</td>
                    <td colspan='4' class="w120 h40">{{data.stu_role}}</td>
                    <td colspan='4' class="w110 h40">担任开始日期</td>
                    <td colspan='4' class="w120 h40">{{data.drksrq}}</td>
                    <td colspan='4' class="w120 h40">担任结束日期</td>
                    <td colspan='4' class="w120 h40">{{data.drjsrq}}</td>
                </tr>
                 <tr>
                    <td colspan='4' class="w120 h40">英文名</td>
                    <td colspan='4' class="w120 h40">{{data.ywxm}}</td>
                    <td colspan='4' class="w110 h40">中文拼音</td>
                    <td colspan='4' class="w120 h40">{{data.xmpy}}</td>
                    <td colspan='4' class="w120 h40">曾用名</td>
                    <td colspan='4' class="w120 h40">{{data.cym}}</td>
                </tr>
                 <tr>
                    <td colspan='4' class="w120 h40">学号</td>
                    <td colspan='4' class="w120 h40">{{data.xh}}</td>
                    <td colspan='4' class="w210 h40">来源地区</td>
                    <td colspan='12' class="w360 ">{{data.lydq}} （{{data.lydqdm}}）</td>
                </tr>
<!-- 家庭经济情况 -->
                 <tr>
                    <td colspan='3' rowspan="3" class="w90 bold">家庭经济情况</td>
                    <td colspan='4' class="w120 h40">户口类型</td>
                    <td colspan='12' class="w360" v-if="data.household_type==2">
                        A、城镇户口(       ) B、农村户口 (   是  )
                    </td>
                    <td colspan='12' class="w360" v-if="data.household_type==1">
                        A、城镇户口(   是   ) B、农村户口 (      )
                    </td>
                    <td colspan='4' class="w120 ">家庭人口总数量</td>
                    <td colspan='4' class="w120 ">{{data.family_size}}</td>
                </tr>
                   <tr>
                    <td colspan='4' class="w120 h40">家庭总收入</td>
                    <td colspan='4' class="w120 h40">{{data.year_income}}</td>
                    <td colspan='4' class="w120 h40">人均月收入</td>
                    <td colspan='4' class="w120 h40">{{data.month_per_income}}</td>
                    <td colspan='4' class="w120 h40">收入来源</td>
                    <td colspan='4' class="w120 h40">{{data.income_source}}</td>
                </tr>
                   <tr>
                    <td colspan='4' class="w120 h40">家庭住址</td>
                    <td colspan='12' class="w360 h40">{{data.location}}</td>
                    <td colspan='4' class="w120 h40">邮政编码</td>
                    <td colspan='4' class="w120 h40">{{data.family_postal_code}}</td>
                </tr>  
<!-- 家庭成员情况 -->
                <tr>
                    <td colspan='3' rowspan='7' class="bold">家庭成员情况</td>
                    <td colspan='4' class="w120 h40">姓名</td>
                    <td colspan='4' class="w120 h40">年龄</td>
                    <td colspan='4' class="w120 h40">联系电话</td>
                    <td colspan='4' class="w120 h40">与本人关系</td>
                    <td colspan='8' class="w240 h40">学习或工作单位</td>
                </tr>
                <tr v-for='(item,index) in parent' :key="index">
                    <td colspan='4' class="w120 h40">{{item.xm}}</td>
                    <td colspan='4' class="w120 h40">{{item.age}}</td>
                    <td colspan='4' class="w120 h40">{{item.mobile}}</td>
                    <td colspan='4' class="w120 h40">{{item.relationship}}</td>
                    <td colspan='8' class="w240 h40">{{item.unit}}</td>
                </tr>
                <tr>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='8' class="w240 h40"></td>
                </tr>
                <tr>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='8' class="w240 h40"></td>
                </tr>
                <tr>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='4' class="w120 h40"></td>
                    <td colspan='8' class="w240 h40"></td>
                </tr>
           
         </table>
         <page-load v-if="flag"></page-load>
    </div>
</template>

<script>
import pageLoad from "../pageload/pageload";
import { studetail } from "../api/login";
import { loginUrl } from "../api/config";
export default {
  components: {
    pageLoad
  },
  data() {
    return {
      loginUrl: loginUrl,
      flag: false,
      data: {},
      parent: []
    };
  },
  mounted() {
    this._studetail();
  },
  methods: {
    _studetail() {
      this.flag = true;
      let module = {
        sfzjh: JSON.parse(sessionStorage.getItem("stuInfo")).sfzjh
      };
      studetail(module).then(res => {
        this.flag = false;
        if (res.status) {
          console.log(res);
          this.data = res.data;
          this.parent = res.data.parent;
        } else {
        }
      });
    },
    back() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.tit {
  width: 810px;
  height: 80px;
  line-height: 80px;
  font-size: 30px;
  font-weight: bold;
  margin: 0 auto;
  text-align: center;
}
.exit {
  font-size: 18px;
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
}
table {
  border-collapse: collapse;
  font-family: 微软雅黑;
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  width: 810px;
}
td {
  box-sizing: border-box;
  border: 1px solid #333;
  color: #333;
}
.w360 {
  width: 360px;
}
.w210 {
  width: 210px;
}
.w240 {
  width: 240px;
}
.w120 {
  width: 120px;
}
.w90 {
  width: 90px;
}
.h40 {
  height: 48px;
}
.bold {
  font-size: bold;
}
.w150 {
  width: 150px;
}

.btns {
  border-radius: 4px;
  padding: 0 40px;
  height: 38px;
  line-height: 38px;
  color: #3a5ae1;
  border: 1px solid #3a5ae1;
  font-size: 16px;
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
  position: absolute;
  right: 10%;
  top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/view/stuInfoing.vue